<template>
  <div class="pdf-preview">
    <el-drawer
      :title="title"
      :visible.sync="visible"
      :before-close="handleClose"
      direction="rtl"
      size="60%"
      class="pdf-drawer"
      :wrapper-closable="false"
    >
      <div class="pdf-container" v-if="pdfUrl">
        <div class="pdf-controls">
          <div class="controls-left">
            <el-button-group>
              <el-button size="small" @click="prevPage" :disabled="currentPage <= 1">
                <i class="el-icon-arrow-left"></i> 上一页
              </el-button>
              <el-button size="small" @click="nextPage" :disabled="currentPage >= pageCount">
                下一页 <i class="el-icon-arrow-right"></i>
              </el-button>
            </el-button-group>
            <span class="page-info">{{ currentPage }} / {{ pageCount }}</span>
          </div>
          <div class="controls-right">
            <el-button size="small" type="primary" @click="handleClose">
              <i class="el-icon-close"></i> 关闭
            </el-button>
          </div>
        </div>
        <div class="pdf-content" v-loading="loading">
          <pdf
            :src="pdfUrl"
            :page="currentPage"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
            @loaded="loading = false"
          ></pdf>
        </div>
      </div>
      <div v-else class="empty-pdf">
        <el-empty description="暂无PDF文件"></el-empty>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfPreview',
  components: {
    pdf
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    pdfUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'PDF预览'
    }
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      loading: true
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.resetState()
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage++
      }
    },
    resetState() {
      this.currentPage = 1
      this.pageCount = 0
      this.loading = true
    }
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetState()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-preview {
  .pdf-drawer {
    ::v-deep .el-drawer__header {
      margin-bottom: 0;
      padding: 16px 20px;
      border-bottom: 1px solid #e4e7ed;
      color: #303133;
      font-size: 16px;
      font-weight: 500;
    }

    .pdf-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      background: #f5f7fa;
      
      .pdf-controls {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        background: #fff;
        border-bottom: 1px solid #e4e7ed;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        
        .controls-left {
          display: flex;
          align-items: center;
          
          .el-button-group {
            margin-right: 20px;
            
            .el-button {
              padding: 8px 15px;
              
              &:not(:last-child) {
                margin-right: -1px;
              }
              
              &:hover {
                z-index: 1;
              }
            }
          }
          
          .page-info {
            font-size: 14px;
            color: #606266;
            background: #f5f7fa;
            padding: 4px 12px;
            border-radius: 4px;
            border: 1px solid #dcdfe6;
          }
        }
        
        .controls-right {
          .el-button {
            padding: 8px 15px;
          }
        }
      }
      
      .pdf-content {
        flex: 1;
        overflow: auto;
        padding: 20px;
        display: flex;
        justify-content: center;
        
        ::v-deep .vue-pdf {
          background: #fff;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          
          canvas {
            max-width: 100%;
            height: auto !important;
          }
        }
      }
    }
    
    .empty-pdf {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      
      ::v-deep .el-empty {
        padding: 40px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style> 